import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import moment from 'moment';
import MesaDayOperationsBonos from "./mesa-day-operations-bonos";
import MesaDayOperationsFCI from "./mesa-day-operations-fci";
import MesaDayOperationsInterm from "./mesa-day-operations-interm";
import useSound from 'use-sound';
import notificationSound from '../../assets/sounds/noti.wav'
import { usePusherChannel } from '../../context/PusherContext';
import { toast } from 'react-toastify';


function MesaOperations() {

    const defaultDate = new Date().toISOString().slice(0,10);
    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));
    const [play] = useSound(notificationSound, {
        volume: 0.25,
      });
    
    const canListen = userProfile.roleid === 1 || userProfile.roleid === 6 || userProfile.roleid === 7;

    //Intermediaciones
    usePusherChannel('exchange-operations-channel', 'pending', (data) => {
        if (!canListen) return;
        toast.info('Operación Intermediaciones: #'+data.exchangeOperation.id, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
        play();
    });

    //Mercado
    usePusherChannel('operations-channel', 'pending', (data) => {
        if (!canListen) return;
        toast.success('Operación Mercado: #'+data.operation.id, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
        play();
    });

    //FCI
    usePusherChannel('fund-operations-channel', 'pending', (data) => {
        if (!canListen) return;
        toast.warning('Operación FCI: #'+data.operation.id, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
        });
        play();
    });

    if(userProfile.roleid !== 7){
        return (
            <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                    <h4 className="fw-bold py-3 mb-2"><span className="text-muted fw-light">Mesa /</span> Operaciones del día ({moment(defaultDate).format('D MMMM')})</h4>

                    <Tabs aria-label="tabs" defaultValue={0} sx={{ bgcolor: 'transparent' }} >
                        <TabList
                            disableUnderline
                            sx={{
                            p: 0.5,
                            gap: 0.5,
                            borderRadius: 'xl',
                            // bgcolor: 'background.level1',
                            bgcolor: 'rgba(131, 118, 109, 0.16)',
                            [`& .${tabClasses.root}[aria-selected="true"]`]: {
                                boxShadow: 'sm',
                                bgcolor: 'background.surface',
                                // bgcolor: '#FFFFFF',
                            },
                            }}
                        >
                            <Tab disableIndicator>Mercado</Tab>
                            <Tab disableIndicator>FCI</Tab>
                            <Tab disableIndicator>Intermediación</Tab>
                        </TabList>
                                
                        <TabPanel value={0}>
                            <MesaDayOperationsBonos />
                        </TabPanel>

                        <TabPanel value={1}>
                            <MesaDayOperationsFCI />
                        </TabPanel>

                        <TabPanel value={2}>
                            <MesaDayOperationsInterm />
                        </TabPanel>

                    </Tabs>
                </div>
            </div>   
        );
    }

    if(userProfile.roleid === 7){
        return (
            <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                    <h4 className="fw-bold py-3 mb-2"><span className="text-muted fw-light">Mesa /</span> Operaciones del día ({moment(defaultDate).format('D MMMM')})</h4>

                    <Tabs aria-label="tabs" defaultValue={0} sx={{ bgcolor: 'transparent' }} >
                        <TabList
                            disableUnderline
                            sx={{
                            p: 0.5,
                            gap: 0.5,
                            borderRadius: 'xl',
                            // bgcolor: 'background.level1',
                            bgcolor: 'rgba(131, 118, 109, 0.16)',
                            [`& .${tabClasses.root}[aria-selected="true"]`]: {
                                boxShadow: 'sm',
                                bgcolor: 'background.surface',
                                // bgcolor: '#FFFFFF',
                            },
                            }}
                        >
                            <Tab disableIndicator>FCI</Tab>
                        </TabList>
                                
                        <TabPanel value={0}>
                            <MesaDayOperationsFCI />
                        </TabPanel>

                    </Tabs>
                </div>
            </div>   
        );

    }
}

export default MesaOperations;